import { create } from "zustand";
import ClearedOrders from "../components/clearedOrders";

const useFirebaseStore = create((set)=>({
    userID:null,
    authStatus:"loading",
    userName:"",
    isAdmin:false,
    AdminName:"Admin",
    userEm:"",
    cartItems:[],
    adminOrders:[],
    clearedOrders:[],
    setUserID:(id)=>set({userID:id}),
    setAuthStatus:(status)=>set({authStatus:status}),
    setIsAdmin:(admin)=>set({isAdmin:admin}),
    setAdminName:(admin)=>set({AdminName:admin}),
    setUsername:(name)=>set({userName:name}),
    setCartItems:(ci)=>set({cartItems:ci}),
    setUserEmail:(em)=>set({userEm:em}),
    setAdminOrders:(o)=>set({adminOrders:o}),
    setClearedOrders:(co)=>set({clearedOrders:co})

}))

export default useFirebaseStore;